/* eslint-disable default-case, no-param-reassign */
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import produce from 'immer';
import LocalStorageService from 'services/local-storage-service';
import { actions, JobsActions } from '.';
import { JobsState } from './types';

const initialState: JobsState = {
  jobFiles: LocalStorageService.getJobOutputs() || [],
  documents: LocalStorageService.getDocuments() || [],
};

const reducer: Reducer<JobsState, JobsActions> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.updateJobFiles): {
        LocalStorageService.updateJobOutputs(action.payload);
        draft.jobFiles = action.payload;
        break;
      }
      case getType(actions.updateDocuments): {
        LocalStorageService.updateDocuments(action.payload);
        draft.documents = action.payload;
        break;
      }
    }

    return draft as JobsState;
  });

export default reducer;
